import { Directive, ElementRef, inject, OnDestroy, OnInit } from '@angular/core';
import { DeviceInfoService } from '@core/services/device-info.service';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  isMobileOverlayBackButtonExcluded,
  MobileOverlayBackButtonHandler,
} from './mobile-overlay-back-button-handler';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'nz-date-picker,nz-range-picker,nz-week-picker,nz-month-picker,nz-quarter-picker,nz-year-picker',
  standalone: false,
})
export class NzDatePickerMobileBackButtonDirective implements OnInit, OnDestroy {
  private readonly datePicker = inject(NzDatePickerComponent);
  private readonly elementRef = inject<ElementRef<Element>>(ElementRef);
  private readonly deviceInfoService = inject(DeviceInfoService);
  private readonly destroy$: ReplaySubject<boolean> = new ReplaySubject(1);
  private readonly mobileBackHandler = new MobileOverlayBackButtonHandler({
    isOverlayOpen: () => this.datePicker.realOpenState,
    closeOverlay: () => this.datePicker.close(),
    shouldHandleBackButton: () =>
      this.deviceInfoService.getInfo().deviceTypeDetected === 'PHONE' &&
      !isMobileOverlayBackButtonExcluded(this.elementRef.nativeElement),
  });

  public ngOnInit(): void {
    this.datePicker.nzOnOpenChange.pipe(takeUntil(this.destroy$)).subscribe(opened => {
      if (opened) {
        this.mobileBackHandler.handleOpened();
        return;
      }

      this.mobileBackHandler.handleClosed();
    });
  }

  public ngOnDestroy(): void {
    this.mobileBackHandler.destroy();
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
